module.exports = __webpack_public_path__ + "img/facebook.150fa491.svg";